module.exports = __webpack_public_path__ + "static/media/IMG_1254.1c7f3f57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/IMG_1254.png
// module id = 312
// module chunks = 0